import { pathOr } from 'ramda';
import { isNilOrEmpty } from 'utils/helpers';
import { transformPreferredDistance } from 'pages/Ticket/CarePlanDetails/helpers';
import pluralize from 'pluralize';
import { capitalize } from 'utils/strings';
var humanizeRequestLocationMessage = function (address, distance) {
    var numericDistance = transformPreferredDistance(distance);
    if (!numericDistance)
        return "ZIP ".concat(address);
    var pluralDistance = pluralize('mile', numericDistance, true);
    return "Within ".concat(pluralDistance, " miles of ZIP ").concat(address);
};
export var getRequestDetails = function (data) {
    if (isNilOrEmpty(data)) {
        return {
            member: { id: '', first_name: '', last_name: '' },
            ticketId: '',
            carePlanType: '',
            requestType: '',
            requestPreferences: '',
            location: '',
            preferred_address: '',
            preferred_distance: ''
        };
    }
    var preferred_address = pathOr('', ['roadmap_v2', 'preferred_address'], data);
    var preferred_distance = pathOr('', ['roadmap_v2', 'preferred_distance'], data);
    return {
        member: {
            id: pathOr('', ['roadmap_v2', 'member', 'id'], data),
            first_name: pathOr('', ['roadmap_v2', 'member', 'first_name'], data),
            last_name: pathOr('', ['roadmap_v2', 'member', 'last_name'], data)
        },
        ticketId: pathOr('', ['roadmap_v2', 'tickets', 0, 'id'], data),
        carePlanType: capitalize(pathOr('', ['roadmap_v2', 'performed_by'], data)),
        requestType: pathOr('', ['roadmap_v2', 'title'], data),
        requestPreferences: pathOr('', ['roadmap_v2', 'special_needs'], data),
        location: humanizeRequestLocationMessage(preferred_address, preferred_distance),
        preferred_address: preferred_address,
        preferred_distance: preferred_distance
    };
};
